import { Box, Container, Grid, Header, SpaceBetween } from "@cloudscape-design/components";
import { IssueGroup } from "../common/types";
import { IssueView } from "./IssueView";
import { useMemo } from "react";
import { groupReviewsBySource } from "../common/formatting/sourceFormat";

export type IssueGroupViewProps = {
  issueGroup: IssueGroup;
  placeName: string;
  issueNumberLookup: Map<string, number>;
};

export function IssueGroupView(props: IssueGroupViewProps) {
  const issueGroup = props.issueGroup;

  const allReviews = useMemo(() => {
    return issueGroup.issues.flatMap((issue) => issue.review_links.map((rl) => rl.review));
  }, [issueGroup.issues]);

  const totalReviewCount = allReviews.length;

  const sourceCounts = useMemo(() => {
    return groupReviewsBySource(allReviews);
  }, [allReviews]);

  const sourceCountsDisplay = useMemo(() => {
    return sourceCounts.map((sc) => `${sc.count} ${sc.source}`).join(' · ');
  }, [sourceCounts]);

  return (
    <Container
      header={
        <Header 
          variant="h3" 
          description={issueGroup.description}
          actions={
            <Box variant="p" color="text-body-secondary">
              {totalReviewCount.toLocaleString()} reviews{sourceCounts.length > 0 && ` (${sourceCountsDisplay})`}
            </Box>
          }
        >
          {issueGroup.name}
        </Header>
      }>
        <SpaceBetween direction="vertical" size="xxs">
          {issueGroup.issues.map((issue) => (
            <IssueView key={issue.uuid} issue={issue} placeName={props.placeName} issueNumber={props.issueNumberLookup.get(issue.uuid) ?? 1} />
          ))}
        </SpaceBetween>
    </Container>
  );
}
